export default function MagGlass() {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11 11L7.90638 7.90638M9.06584 5.03292C9.06584 7.26024 7.26024 9.06584 5.03292 9.06584C2.8056 9.06584 1 7.26024 1 5.03292C1 2.8056 2.8056 1 5.03292 1C7.26024 1 9.06584 2.8056 9.06584 5.03292Z"
        stroke="#828282"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
